module.exports = __webpack_public_path__ + "static/media/banner_420.9b28b248.jpg";